import {
  RECEIVE_WELCOME_CENTER_DOC,
  RECEIVE_WELCOME_CENTER_DOC_FAILURE,
  DOC_PATH,
  DOC_FETCH_MODE,
} from '../constants';

const receiveDocContent = (welcomeCenterDoc) => ({
  type: RECEIVE_WELCOME_CENTER_DOC,
  welcomeCenterDoc,
});

const fetchDocFailure = (ex) => {
  return {
    type: RECEIVE_WELCOME_CENTER_DOC_FAILURE,
    ex: ex,
  };
};

export function getLandingDoc() {
  return (dispatch) => {
    return fetch(DOC_PATH + 'welcome-center.json', DOC_FETCH_MODE)
      .then((res) => res.json())
      .then((body) => dispatch(receiveDocContent(body)))
      .catch((ex) => dispatch(fetchDocFailure(ex)));
  };
}
